import { useCallback } from "react";
import { useContent } from "@/context/ContentContext";
import { DEFAULT_TEXTS } from "@/lib/texts";

export function useText() {
  const { content } = useContent();
  const texts = content?.texts;
  return useCallback((key) => {
    const v = texts?.[key];
    return v != null && v !== "" ? v : DEFAULT_TEXTS[key] || "";
  }, [texts]);
}
